__turbopack_context__.v({
  "className": "hellix_3fbaffdd-module__5Tv0OW__className",
});
